import React from 'react';
import PropTypes from 'prop-types';

import GraphConstants from 'app/shared/constants/GraphConstants';

import Text from '@zg-rentals/multibrand-ui/lib/Text';

import {
    ResponsiveContainer,
    PieChart,
    Pie,
    Legend,
    Tooltip,
    Cell,
} from 'recharts';

const propTypes = {
    data: PropTypes.array,
};

const defaultProps = {
    data: [],
};

const BasicPieChart = ({
    title,
    data,
}) => (
    <div className="PieChart">
        {title && <Text type="h5" emphasize={true}>{title}</Text>}
        <ResponsiveContainer width="100%" height={300}>
            <PieChart>
                <Legend />
                <Tooltip />
                <Pie
                    data={data}
                    dataKey="value"
                    fill={GraphConstants.COLORS.zillow.primary}
                >
                    {data.map((entry, i) => <Cell key={`cell-${i}`} fill={entry.fill || '#006aff'} />)}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    </div>
);

BasicPieChart.propTypes = propTypes;
BasicPieChart.defaultProps = defaultProps;

export default BasicPieChart;
